import { render } from "./LesTuteurs.vue?vue&type=template&id=036ab29b&scoped=true&ts=true"
import script from "./LesTuteurs.vue?vue&type=script&lang=ts"
export * from "./LesTuteurs.vue?vue&type=script&lang=ts"

import "./LesTuteurs.vue?vue&type=style&index=0&id=036ab29b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036ab29b"]])

export default __exports__